export default "__VITE_ASSET__CHb_SX0l__"